// extracted by mini-css-extract-plugin
export var element = "Option-module--element--ZlQYZ";
export var selected = "Option-module--selected--niLUi";